/** The portal mark: a link glyph on the accent, ported from the portal prototype. */
export function PortalMark({ className = "plogo" }: { className?: string }) {
  return (
    <span className={className} aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M9.5 14.5l5-5" />
        <path d="M11.5 7.5l1-1a3.4 3.4 0 0 1 4.8 4.8l-1 1" />
        <path d="M12.5 16.5l-1 1a3.4 3.4 0 0 1-4.8-4.8l1-1" />
      </svg>
    </span>
  );
}
